import { ROLES } from './../menu/items';
import { AutenticacionService } from 'src/app/servicios/autenticacion.service';
import { Pago, PagosService, ESTADOS_PAGO } from './../../../servicios/pagos.service';
import { ResultadoServicio } from './../../../servicios/lugares.service';
import { TIPOS_VISITAS, Visitante, VisitantesService, VisitantesUnidad } from './../../../servicios/visitantes.service';
import { Component, AfterViewInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { merge, of as observableOf } from 'rxjs';
import { catchError, debounceTime, filter, map } from 'rxjs/operators';
import { Lugar, LugaresService } from 'src/app/servicios/lugares.service';
import { UsuariosService } from 'src/app/servicios/usuarios.service';
import moment from 'moment';
import { SocketService } from 'src/app/services/socket.service';
import { ToastService } from 'src/app/servicios/toast.service';

enum TIPOS_PAGOS {
  ACTIVOS = 1,
  HISTORIAL = 0
}
@Component({
  selector: 'app-tabla-general',
  templateUrl: './tabla-general.component.html',
  styleUrls: ['./tabla-general.component.scss']
})
export class TablaGeneralComponent implements AfterViewInit, OnDestroy {
  @Output() tipoVisitasChange = new EventEmitter<number>();

  // Modulo visitantes
  TIPOS_VISITAS = TIPOS_VISITAS;
  tipoVisitas = TIPOS_VISITAS.TODOS;

  // Modulo pagos
  TIPOS_PAGOS = TIPOS_PAGOS;
  tipoPagos = TIPOS_PAGOS.ACTIVOS;

  ESTADOS_PAGO = ESTADOS_PAGO;
  @Input() moduloActual: string;
  @Input() displayedColumns: any[] = [];
  data: Lugar[] | Visitante[] | any[] = [];
  hide = false;

  cargandoDatos = true;
  isRateLimitReached = false;
  paginaActual = 0;
  ultimaPagina;

  elementosPorPagina = 8;

  private socketSub: any;

  constructor(
    private visitantesService: VisitantesService,
    private lugaresService: LugaresService,
    private pagosService: PagosService,
    private router: Router,
    private autenticacionService: AutenticacionService,
    private socketService: SocketService,
    private usuariosService: UsuariosService,
    private toastService: ToastService,
  ) {
    console.log('[TablaGeneralComponent] Constructor ejecutado. moduloActual:', this.moduloActual);
  }

  public filtrosForm: UntypedFormGroup = new UntypedFormGroup({
    palabrasClave: new UntypedFormControl(""),
    fechaInicio: new UntypedFormControl(moment().set({
      hours: 0,
      minutes: 0,
      seconds: 0
    })),
    fechaFinal: new UntypedFormControl(moment().set({
      hours: 23,
      minutes: 0,
      seconds: 0
    }))
  })

  ngOnInit() {
    this.palabrasClaveValueChange();
    this.fechasValueChange();

    if(this.moduloActual === "pagos") {
      this.pagosService.detallePago.subscribe(res => {
        if(!res) {
          this.cargarDatosTabla();
        }
      });
    }

    // Suscribirse a eventos de la unidad por WebSocket solo si es modulo visitantes
    if (this.moduloActual === 'visitantes') {
      console.log('[TablaGeneralComponent] Suscribiéndose a socket para visitantes...');
      const dataString = localStorage.getItem('data_login');
      let unidadId = 0;
      if (dataString) {
        try {
          const data_login = JSON.parse(dataString);
          unidadId = data_login?.company_id || 0;
        } catch (e) {
          unidadId = 0;
        }
      }
      this.socketSub = this.socketService.listenUnidad(unidadId)
        .subscribe(data => {
          console.log('[TablaGeneralComponent] Evento recibido en subscribe del socket:', data);
          console.log('[SOCKET][TablaGeneralComponent] Evento recibido, recargando visitantes. Status actual:', this.tipoVisitas, 'Data evento:', data);
          // Refrescar la lista de visitantes con el status seleccionado
          this.cargarDatosVisitantes();
        });
    }
  }
  ngOnDestroy() {
    if (this.socketSub) this.socketSub.unsubscribe();
  }

  ngAfterViewInit() {
    this.cargarDatosTabla();
  }
  
  public cargarDatosTabla() {
    switch (this.moduloActual) {
      case "lugares":
        this.cargarDatosApartamentos();
        break;
      case "citofonia":
        this.cargarDatosApartamentos();
        break;
      case "visitantes":
        this.cargarDatosVisitantes();
        break;
      case "pagos":
        this.cargarDatosPagos();
        break;
      case "usuarios":
        this.cargarDatosUsuarios();
        break;
      default:
        this.cargarDatosApartamentos();
        break;
    }
  }

  public cargarDatosUsuarios() {
    this.cargandoDatos = true;
    const palabra = (this.filtrosForm.get("palabrasClave").value || "").toLowerCase().trim();
    
    let unidadId = 0;
    const dataString = localStorage.getItem('data_login');
    if (dataString) {
      try {
        const data_login = JSON.parse(dataString);
        unidadId = data_login?.company_id || 0;
      } catch (e) {
        unidadId = 0;
      }
    }

    if (!unidadId) {
      this.cargandoDatos = false;
      this.data = [];
      return;
    }

    this.usuariosService.listarUsuariosMasivos(unidadId).subscribe({
      next: (res) => {
        this.cargandoDatos = false;
        const rawUsers = res?.data?.data || [];
        
        // Mapear campos para visualización uniforme (ej: lugar_render)
        const mappedUsers = rawUsers.map(u => ({
          ...u,
          lugar_render: u.lugar_asignado || (u.area_name && u.site_name ? `${u.area_name} - ${u.site_name}` : (u.site_name || u.lugar_asignado || 'Sin asignar'))
        }));

        // Filtrar localmente por palabra clave
        let filtered = mappedUsers;
        if (palabra) {
          filtered = mappedUsers.filter(u => 
            (u.us_nombres || '').toLowerCase().includes(palabra) ||
            (u.us_apellidos || '').toLowerCase().includes(palabra) ||
            (u.us_numero_documento || '').includes(palabra) ||
            (u.us_correo || '').toLowerCase().includes(palabra) ||
            (u.us_celular || '').includes(palabra) ||
            (u.estado_legible || '').toLowerCase().includes(palabra) ||
            (u.lugar_render || '').toLowerCase().includes(palabra)
          );
        }

        // Configurar última página para el paginador
        this.ultimaPagina = Math.max(0, Math.ceil(filtered.length / this.elementosPorPagina) - 1);

        // Si la página actual excede el rango después de un filtro, la reseteamos
        if (this.paginaActual > this.ultimaPagina) {
          this.paginaActual = 0;
        }

        // Paginación local
        this.data = filtered.slice(this.paginaActual * this.elementosPorPagina, (this.paginaActual + 1) * this.elementosPorPagina);
      },
      error: (err) => {
        this.cargandoDatos = false;
        console.error('Error al cargar usuarios masivos:', err);
        this.data = [];
      }
    });
  }

  public cargarDatosApartamentos() {
    this.cargandoDatos = true;
    this.lugaresService.getLugares(this.paginaActual, this.filtrosForm.get("palabrasClave").value)
      .pipe(catchError(() => observableOf(null)), map(data => {
        this.cargandoDatos = false;
        this.isRateLimitReached = data === null;

        if (data === null) {
          return [];
        }

        return data.data.lugares;
      })).subscribe(data => {
        if(data.length === 0 && this.paginaActual > 0) {
          this.paginaAnterior();
          this.ultimaPagina = this.paginaActual;
        } else {
          this.data = data;
        }
      });
  }

  public cargarDatosVisitantes() {
    this.cargandoDatos = true;
    this.visitantesService.traerVisitantes(
      this.paginaActual,
      this.tipoVisitas,
      this.filtrosForm.get("palabrasClave").value,
      this.filtrosForm.get("fechaInicio").value.format("YYYY-MM-DD"),
      this.filtrosForm.get("fechaInicio").value.format("HH:mm:ss"),
      this.filtrosForm.get("fechaFinal").value.format("YYYY-MM-DD"),
      this.filtrosForm.get("fechaFinal").value.format("HH:mm:ss"),
      )
    .pipe(catchError(() => observableOf(null)), map((res: ResultadoServicio<VisitantesUnidad>) => {
      this.cargandoDatos = false;
      this.isRateLimitReached = res === null;

      if (res === null) {
        return [];
      }

      return res.data.visitantes.map(visitante => {
        // TODO: Revisar que siempre se devuelva
        const dateCheckIn = moment(visitante.date_checkin);
        const hhmmssCheckIn = (visitante.hour_checkin || "").split(":");
        const dateCheckOut = moment(visitante.date_checkin);
        const hhmmssCheckOut = (visitante.hour_checkout || "").split(":");

        dateCheckIn.set("hour", parseInt(hhmmssCheckIn[0]));
        dateCheckIn.set("minute", parseInt(hhmmssCheckIn[1]));

        dateCheckOut.set("hour", parseInt(hhmmssCheckOut[0]));
        dateCheckOut.set("minute", parseInt(hhmmssCheckOut[1]));

        let vehiculo = 'Sin vehiculo';

        if(visitante.type_vehicle && visitante.plate_vehicle) {
          vehiculo = `${visitante.type_vehicle}/${visitante.plate_vehicle}`
        } else if (visitante.type_vehicle) {
          vehiculo = visitante.type_vehicle
        }

        return {
          ...visitante,
          hour_checkin: dateCheckIn.format("DD-MM-YYYY hh:mm a" ),
          hour_checkout: (visitante.hour_checkout !== "00:00:00") ? dateCheckOut.format("DD-MM-YYYY hh:mm a") : dateCheckOut.format("DD-MM-YYYY"),
          vehiculo,
          note: visitante.note ?? "-"
        }
      });
    })).subscribe(data => {
      if(data.length === 0 && this.paginaActual > 0) {
        this.paginaAnterior();
        this.ultimaPagina = this.paginaActual;
      } else {
        this.data = data;
      }
    });
  }

  public cargarDatosPagos() {
    this.cargandoDatos = true;
    this.pagosService.traerPagosUnidad(
      this.paginaActual,
      this.filtrosForm.get("palabrasClave").value,
      this.tipoPagos,
      this.filtrosForm.get("fechaInicio").value.unix(),
      this.filtrosForm.get("fechaFinal").value.unix(),
    )
      .pipe(catchError(() => observableOf(null)), map(data => {
        this.cargandoDatos = false;
        this.isRateLimitReached = data === null;

        if (data === null) {
          return [];
        }

        if(data.data.pagos.length === 0 && this.paginaActual>0) {
          this.paginaActual--;
          return this.data
        }

        return data.data.pagos.map((pago: Pago) => ({
          ...pago,
          user_name: pago.user_name + (pago.user_lastname ?  ` ${pago.user_lastname}` : ""),
          type_charge: pago.type_charge && this.capitalize(pago.type_charge),
          type_payment: pago.type_payment && this.capitalize(pago.type_payment),
          date: moment.unix(pago.date).format("DD-MM-YYYY")
        }));
      })).subscribe(data => {
        if(data.length === 0 && this.paginaActual > 0) {
          this.paginaAnterior();
          this.ultimaPagina = this.paginaActual;
        } else {
          this.data = data;
        }
      });
  }

  public get displayedColumnsNames(): string[] {
    return this.displayedColumns.map(column => column.nombre)
  }

  public editar(id) {
    switch (this.moduloActual) {
      case 'lugares':
        this.router.navigate(['lugares', 'apartamentos', id]);
        break;
      case 'citofonia':
        this.router.navigate(['citofonia', 'apartamentos', id]);
        break;
      case 'visitantes':
        this.router.navigate(['visitantes', id]);
        break;
      default:
        break;
    }
  }

  public palabrasClaveValueChange() {
    this.filtrosForm.get("palabrasClave")
      .valueChanges
      .pipe(
        filter(value => value && value.length > 1 || value === ""),
        debounceTime(1200),
        // distinctUntilChanged()
      )
      .subscribe(() => {
        this.paginaActual = 0;
        this.cargarDatosTabla();
      })
  }

  public quitarPalabrasClave() {
    this.filtrosForm.get("palabrasClave").setValue("");
    this.cargarDatosTabla();
  }

  public fechasValueChange() {
    merge(
      this.filtrosForm.get("fechaInicio").valueChanges,
      this.filtrosForm.get("fechaFinal").valueChanges
    ).subscribe(() => {
      this.paginaActual = 0;
      this.cargarDatosTabla()
    });
    
  }

  public numSequence(n: number): Array<number> {
    return Array(n);
  }

  public actualizarPagina(nuevaPagina: number): void {
    this.cargandoDatos = true;
    this.paginaActual = nuevaPagina;
    this.cargarDatosTabla();
  }

  public mostrarModalVerificarPago(detallePago: Pago): void {
    this.pagosService.cambiarDetallePago(detallePago.id);
  }

  public paginaAnterior() {
    this.cargandoDatos = true;
    this.paginaActual--;
    this.cargarDatosTabla();
  }

  public paginaSiguiente() {
    this.cargandoDatos = true;
    this.paginaActual++;
    this.cargarDatosTabla();
  }

  get usuarioEsCelador() {
    return this.autenticacionService.dataLogin.role === ROLES.CELADOR;
  }

  capitalize(word) {
    const lower = word.toLowerCase();
    return word.charAt(0).toUpperCase() + lower.slice(1);
  }

  // Modulo visitantes

  cambiarTipoVisitas(nuevoTipo) {
    this.paginaActual = 0;
    this.tipoVisitas = nuevoTipo;
    if (nuevoTipo === this.TIPOS_VISITAS.HISTORIAL) {
      this.filtrosForm.get('fechaInicio').setValue(moment().startOf('year'), { emitEvent: false });
    } else {
      this.filtrosForm.get('fechaInicio').setValue(moment().set({
        hours: 0,
        minutes: 0,
        seconds: 0
      }), { emitEvent: false });
    }
    this.tipoVisitasChange.emit(nuevoTipo);
    this.cargarDatosVisitantes();
  }

  // Modulo pagos

  cambiarTipoPagos(nuevoTipo) {
    this.paginaActual = 0;
    this.tipoPagos = nuevoTipo;
    this.cargarDatosPagos();
  }

  mostrarModalCargarPagos() {
    this.pagosService.cambiarMostrarModalCargarPagos(true);
  }

  reenviarCorreo(row: any) {
    const usId = row.us_id || row.id;
    let urId = 0;
    const dataString = localStorage.getItem('data_login');
    if (dataString) {
      try {
        const data_login = JSON.parse(dataString);
        urId = data_login?.company_id || 0;
      } catch (e) {
        urId = 0;
      }
    }

    if (!usId || !urId) {
      this.toastService.mostrarToast("No se encontró el ID del usuario o de la unidad para reenviar el correo.");
      return;
    }

    this.cargandoDatos = true;
    this.usuariosService.reenviarCorreo(usId, urId).subscribe({
      next: (res) => {
        this.cargandoDatos = false;
        const msg = res?.data?.message || res?.message || "Correo reenviado exitosamente.";
        this.toastService.mostrarToast(msg);
        this.cargarDatosUsuarios();
      },
      error: (err) => {
        this.cargandoDatos = false;
        console.error('Error al reenviar correo:', err);
        const errorMsg = err?.error?.data?.message || err?.error?.message || "Error al reenviar el correo.";
        this.toastService.mostrarToast(errorMsg);
      }
    });
  }
}